import * as squint_core from 'squint-cljs/core.js';
import * as preact from 'preact';
import * as dom from './cljdoc.client.dom.jsx';
import * as cljdoc_DOT_client_DOT_dom from './cljdoc.client.dom.jsx';
import * as lib from './cljdoc.client.library.jsx';
import * as cljdoc_DOT_client_DOT_library from './cljdoc.client.library.jsx';
var day_date = function (date) {
return (new Date(date.getFullYear(), date.getMonth(), date.getDate()));

};
var last_viewed_message = function (p__11347) {
const map___1_3 = p__11347;
const map___1_4 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___1_3))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___1_3))) ? (map___1_3) : (squint_core.seq_to_map_for_destructuring(map___1_3)))) : (map___1_3));
const last_viewed_5 = squint_core.get(map___1_4, "last_viewed");
if (squint_core.truth_(last_viewed_5)) {
const activity_day_6 = day_date((new Date(last_viewed_5)));
const now_day_7 = day_date((new Date()));
const ms_per_day_8 = 86400000;
const days_ago_9 = (((now_day_7 - activity_day_6) / ms_per_day_8) | 0);
return `${" last viewed "}${(((days_ago_9 === 0)) ? ("today") : ((((1 === days_ago_9)) ? ("1 day ago") : ((("else") ? (`${days_ago_9}${" days ago"}`) : (null))))))??''}`;
};

};
var init_doc_links = function (doc_links) {
const previously_opened_1 = (() => {
const G__11348_2 = localStorage;
const G__11348_3 = (((G__11348_2 == null)) ? (null) : (G__11348_2.getItem("previously_opened")));
if ((G__11348_3 == null)) {
return null} else {
return JSON.parse(G__11348_3)};

})();
if ((squint_core.count(previously_opened_1) > 0)) {
if ((squint_core.count(previously_opened_1) >= 3)) {
const temp__6897__auto___4 = document.querySelector("[data-id='cljdoc-examples']");
if (squint_core.truth_(temp__6897__auto___4)) {
const examples_5 = temp__6897__auto___4;
examples_5.remove()}};
return preact.render(<div><p class="mt4 mb0"><div class="fw5">Pick up where you left off:</div><ul class="mv0 pl0 list">{(() => {
const recents_6 = squint_core.reverse(previously_opened_1).slice(0, 3);
return squint_core.mapv((function (visited) {
return <li class="mr1 pt2"><a class="link blue nowrap" href={lib.docs_path(visited)}>{lib.project(visited)}<span class="gray f6">{last_viewed_message(visited)}</span></a></li>;

}), recents_6);

})()}</ul></p></div>, doc_links);
};

};
var init = function () {
const temp__6897__auto___1 = dom.query("[data-id='cljdoc-doc-links']");
if (squint_core.truth_(temp__6897__auto___1)) {
const recently_visited_node_2 = temp__6897__auto___1;
return init_doc_links(recently_visited_node_2);
};

};

export { init }
